import { defineComponent as _defineComponent } from 'vue'
import { useRouter } from 'vue-router/composables';
import { computed, PropType } from 'vue';
import store from '@/store/store';
import { BillingInfoSubscriptionStatus } from '@/model/Account';
import { TranslateResult } from 'vue-i18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'PaywallUpgradeAlert',
  props: {
  text: { type: [String, Object] as PropType<string|TranslateResult>, required: false, default: '' },
},
  setup(__props) {

const props = __props;

const router = useRouter();

const isVIP = computed(() => store.state.settings.account.subStatus === BillingInfoSubscriptionStatus.VIP);



const upgradePlanAction = () => {
  router.push('/settings/billing?upgrade=true');
};


return { __sfc: true,router, isVIP, props, upgradePlanAction }
}

})